import React, { useCallback } from "react"

import TrendColorEditor from "./TrendColorEditor"
import TrendStyleEditor from "./TrendStyleEditor"
import TrendLabelEditor from "./TrendLabelEditor"
import { getMatchingTrend } from "../../../resources/utils"

export default function TrendEditor({
  obs,
  observations,
  tag_category,
  graph,
  graphIndex,
  plotConfigUpdater,
  intl,
}) {
  const updateGraph = useCallback(
    (tag, value, category) => {
      observations
        .filter((obv) => getMatchingTrend(obv, tag))
        .forEach((obv) => {
          obv[category] = value
        })

      graph[tag_category] = observations
      plotConfigUpdater(graph, graphIndex)
    },
    [observations, graph, plotConfigUpdater, tag_category, graphIndex],
  )

  const adjustMetric = useCallback((tag, value, category) => {
    if (value !== tag[category]) {
      updateGraph(tag, value, category)
    }
  }, [])

  const rowStyle = { display: "flex", margin: "5px 0" }

  return (
    <>
      <TrendColorEditor
        colorSelect={(col) => adjustMetric(obs, col, "colour")}
        intl={intl}
        rowStyle={rowStyle}
      />
      <hr />
      <TrendStyleEditor obs={obs} rowStyle={rowStyle} adjustMetric={adjustMetric} intl={intl} />
      <hr />
      <TrendLabelEditor obs={obs} rowStyle={rowStyle} adjustMetric={adjustMetric} intl={intl} />
    </>
  )
}
